module.exports = __webpack_public_path__ + "static/media/slide3.c27d7cb1.png";